module.exports = __webpack_public_path__ + "static/media/photo43.a3d2f836.jpg";